/* eslint no-unused-vars: 0, func-names: 0, eqeqeq: 0, no-mixed-operators: 0, max-len: 0, no-shadow: 0 */
export default function (informer, teaser, teaserContent) {
  this.informer = informer;

  this.getTeaserTpl = function (rowNum, teaserNum) {
    const tn = rowNum * this.informer.cols + teaserNum;

    const categoryItem = this.informer.category_visible
      ? `\n\t\t\t<p class="%INF_PREF%cat%INF_ID%">%CAT-${tn}%</p>`
      : "";
    const textItem = `<div class="%INF_PREF%text%INF_ID%">
                <a class="%INF_PREF%title%INF_ID%" href="%URL-${tn}%" target="_blank">%TITLE-${tn}%</a>${categoryItem}
            </div>`;

    const imgItem =
      this.informer.img_size !== "0_0"
        ? `<div class="%INF_PREF%img%INF_ID%">
                <a href="%URL-${tn}%" target="_blank"><img src="%IMG-${tn}%" /></a>
            </div>`
        : "";

    let teaser;

    if (this.informer.img_align === "top") {
      teaser = `
    <div class="%INF_PREF%teaser-container%INF_ID%">
        <div class="%INF_PREF%teaser%INF_ID%">
            ${textItem}
            ${imgItem}
        </div>
    </div>`;
    } else {
      teaser = `
    <div class="%INF_PREF%teaser-container%INF_ID%">
        <div class="%INF_PREF%teaser%INF_ID%">
            ${imgItem}
            ${textItem}
        </div>
    </div>`;
    }

    return teaser;
  };

  this.getRow = function (rowNum) {
    let result =
      '\n\t<!-- teaser row -->\n\t<div class="%INF_PREF%teaser-row%INF_ID%">';

    for (let teaserNum = 0; teaserNum < informer.cols; teaserNum++) {
      result += this.getTeaserTpl(rowNum, teaserNum);
    }

    result += "\n\t</div>\n\t<!-- end teaser row -->";

    return result;
  };

  // return ready to use informer template
  this.getInformerTempl = function () {
    let result = '<div class="%INF_PREF%informer%INF_ID%">';

    for (let rowNum = 0; rowNum < this.informer.rows; rowNum++) {
      result += this.getRow(rowNum);
    }

    result += "\n</div>";

    return result;
  };

  this.getTeaserBorderCss = function () {
    let teaserBorder = "";

    if (parseInt(this.informer.teaser_margin)) {
      teaserBorder = `
.%INF_PREF%teaser%INF_ID% {
    border: ${this.informer.teaser_border_width}px solid ${this.informer.teaser_border_color};
}
`;
    } else {
      teaserBorder = `
            .%INF_PREF%teaser%INF_ID% {
                border-top: ${this.informer.teaser_border_width}px solid ${this.informer.teaser_border_color};
                border-left: ${this.informer.teaser_border_width}px solid ${this.informer.teaser_border_color};
            }
            .%INF_PREF%teaser-container%INF_ID%:last-child .%INF_PREF%teaser%INF_ID% {
                border-right: ${this.informer.teaser_border_width}px solid ${this.informer.teaser_border_color};
            }
            .%INF_PREF%teaser-row%INF_ID%:last-child .%INF_PREF%teaser%INF_ID% {
                border-bottom: ${this.informer.teaser_border_width}px solid ${this.informer.teaser_border_color};
            }
            `;
    }

    return teaserBorder;
  };

  // returns ready to use css template
  this.getCssTempl = function () {
    let imgFloat = "none";

    if (
      this.informer.img_align == "left" ||
      this.informer.img_align == "right"
    ) {
      imgFloat = this.informer.img_align;
    }

    let imgMarginType = "right";

    if (this.informer.img_align === "right") {
      imgMarginType = "left";
    } else if (this.informer.img_align === "top") {
      imgMarginType = "top";
    } else if (this.informer.img_align === "bottom") {
      imgMarginType = "bottom";
    }

    const titleListStyle =
      this.informer.img_size !== "0_0"
        ? ""
        : `
    display: list-item;
    list-style: ${this.informer.list_style} inside
        `;
    const result = `
.%INF_PREF%informer%INF_ID% * {
    font-size: 0;
    padding: 0;
    margin: 0;
    border-width: 0;
    box-sizing: border-box;
}
.%INF_PREF%informer%INF_ID% {
    border: ${this.informer.border_width}px solid ${this.informer.border_color};
    width: ${this.informer.width}${this.informer.width_unit};
}
.%INF_PREF%teaser-container%INF_ID% {
    display: inline-block;
    width: ${100 / this.informer.cols}%;
    vertical-align: top;
}
.%INF_PREF%teaser-container%INF_ID%:after {
    display: table;
    content: "";
}

.%INF_PREF%teaser%INF_ID% {
    padding: ${this.informer.teaser_padding}px;

    background-color: ${this.informer.teaser_background_color};

    margin-top: ${this.informer.teaser_margin}px;
    margin-left: ${this.informer.teaser_margin}px;

}
.%INF_PREF%teaser-container%INF_ID%:last-child .%INF_PREF%teaser%INF_ID% {
    margin-right: ${this.informer.teaser_margin}px;
}
.%INF_PREF%teaser-row%INF_ID%:last-child .%INF_PREF%teaser%INF_ID% {
    margin-bottom: ${this.informer.teaser_margin}px;
}
.%INF_PREF%teaser%INF_ID%:after {
    content: "";
    display: table;
    clear: both;
}

${this.getTeaserBorderCss()}

.%INF_PREF%img%INF_ID% {
    float: ${imgFloat};
    margin-${imgMarginType}: ${this.informer.img_margin}px;
}
.%INF_PREF%img%INF_ID% img {
    border: ${this.informer.img_border_width}px solid ${
      this.informer.img_border_color
    };
}
a.%INF_PREF%title%INF_ID% {
    font-family: ${this.informer.title_font_family};
    font-size: ${this.informer.title_font_size}px;
    color: ${this.informer.title_font_color};

    font-weight: ${this.informer.title_bold ? "bold" : "normal"};
    font-style: ${this.informer.title_italic ? "italic" : "normal"};
    text-decoration: ${this.informer.title_underline ? "underline" : "none"};
    ${titleListStyle}
}
a.%INF_PREF%title%INF_ID%:hover {
    color: ${this.informer.title_font_color_hover};

    font-weight: ${this.informer.title_bold_hover ? "bold" : "normal"};
    font-style: ${this.informer.title_italic_hover ? "italic" : "normal"};
    text-decoration: ${
      this.informer.title_underline_hover ? "underline" : "none"
    };
}
.%INF_PREF%cat%INF_ID% {
    font-size: ${this.informer.category_font_size}px;
    color: ${this.informer.category_font_color};
}
.%INF_PREF%text%INF_ID% {
    text-align: ${this.informer.text_align};
}
`;
    return result;
  };

  this.renderFull = function (
    prefix,
    informerId,
    teasers,
    cssTempl,
    informerTempl
  ) {
    let css = cssTempl
      .replace(/%INF_PREF%/g, prefix)
      .replace(/%INF_ID%/g, informerId);
    let html = informerTempl
      .replace(/%INF_PREF%/g, prefix)
      .replace(/%INF_ID%/g, informerId);

    css = `<style>${css}</style>`;
    html = html.replace(/>[\n\s]+</g, "><");

    for (let i = 0; i < teasers.length; i++) {
      html = html.replace(new RegExp(`%TITLE-${i}%`, "g"), teasers[i].title);
      html = html.replace(
        new RegExp(`%CAT-${i}%`, "g"),
        teasers[i].category_name
      );
      html = html.replace(new RegExp(`%URL-${i}%`, "g"), teasers[i].url);
      html = html.replace(new RegExp(`%IMG-${i}%`, "g"), teasers[i].image.url);
    }

    return css + html;
  };
}
